export { default } from './BubbleTitle'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BubbleTitle/index.js